import { aboutData } from '@/mocks/about';

export default function AboutHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20liquid%20gradient%20with%20rich%20crimson%20red%20and%20deep%20warm%20black%20tones%2C%20dynamic%20motion%20blur%20effect%2C%20golden%20and%20amber%20accent%20streaks%20flowing%20diagonally%2C%20luxurious%20dark%20artistic%20background%2C%20high%20saturation%20warm%20palette%2C%20modern%20editorial%20style%2C%20pure%20abstract%20art%2C%20professional%20cinematic%20mood&width=1920&height=600&seq=about-hero-bg&orientation=landscape"
          alt="关于吃瓜网站线路一"
          title="吃瓜网站线路一 - 关于我们"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      <div className="relative z-10 text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading mb-3">
          {aboutData.hero.title}
        </h1>
        <p className="text-xl md:text-3xl text-white/90 font-heading italic mb-4">
          {aboutData.hero.subtitle}
        </p>
        <p className="text-sm md:text-base text-white/60 font-body max-w-xl mx-auto">
          {aboutData.hero.description}
        </p>
      </div>
    </section>
  );
}